import gql from 'graphql-tag'

export const GET_SETTING = gql`
  query {
    setting {
      name
    }
  }
`

export const GET_SETTING_USER = gql`
  query {
    setting {
      id
      name
      maxUsers
      availableAndReservedCredit
    }
  }
`

export const GET_MAIN_STOCK = gql`
  query {
    setting {
      id
      mainStock {
        id
      }
    }
  }
`

export const GET_PRODUCT_TAGS = gql`
  query getProductTags {
    setting {
      id
      productTags
    }
  }
`

export const GET_PRODUCT_LOCATIONS = gql`
  query getProductLocations {
    setting {
      id
      productLocations
    }
  }
`

export const GET_SHOP_URL = gql`
  query GetShopUrl {
    setting {
      id
      shopurl
    }
}
`

export const GET_TRANSPORT_KEY = gql`
  query GetTransportKey {
    setting {
      id
      dhlAccountId
      shipjungToken
      scgMemberCode
    }
  }

`

export const GET_SETTING_ORDER = gql`
  query {
    setting {
      id
      vatExclude
      defaultTaxInvoice
      defaultShippingType
      shippingTypes
    }
  }
`

export const GET_CUSTOMERTAGS = gql`
  query {
    setting {
      id
      customerTags
    }
  }
`

export const GET_SHOP_ADDRESS = gql`
  query {
    setting {
      id
      address
    }
  }
`

export default {
  GET_SETTING,
  GET_SETTING_USER,
  GET_MAIN_STOCK,
  GET_PRODUCT_TAGS,
  GET_PRODUCT_LOCATIONS,
  GET_SHOP_URL,
  GET_TRANSPORT_KEY,
  GET_SETTING_ORDER,
  GET_CUSTOMERTAGS,
  GET_SHOP_ADDRESS
}
